import React from "react";

function Footer() {
  return (
    <div className="footer">
      <p> Made by Giuseppe </p>
    </div>
  );
}

export default Footer;
